// src/services/companyLicenseService.js

import axiosInstance from "../config/axiosInstance";

const BASE_URL = "/companylicense";

/**
 * Obtiene la lista paginada de licencias de empresa.
 * @param {number} page - Número de página (inicia en 1)
 * @param {number} size - Cantidad de elementos por página
 * @returns {Promise<ApiResponse<PaginatedResult<CompanyLicenseListDto>>>}
 */
export const getCompanyLicenses = async (page = 1, size = 10, searchTerm) => {
  const params = new URLSearchParams({
    pageIndex: page.toString(),
    pageSize: size.toString(),
  });

  if (searchTerm?.trim()) {
    params.append("searchTerm", searchTerm.trim());
  }

  const response = await axiosInstance.get(`${BASE_URL}?${params.toString()}`);
  return response.data;
};

/**
 * Obtiene una licencia de empresa por su ID.
 * @param {string} id - ID de la licencia
 * @returns {Promise<ApiResponse<CompanyLicenseDto>>}
 */
export const getCompanyLicenseById = async (id) => {
  const response = await axiosInstance.get(`${BASE_URL}/${id}`);
  return response.data;
};

/**
 * Crea una nueva licencia de empresa.
 * @param {CreateCompanyLicenseDto} data - Datos para la creación
 * @returns {Promise<ApiResponse<CompanyLicenseDto>>}
 */
export const createCompanyLicense = async (data) => {
  const response = await axiosInstance.post(BASE_URL, data);
  return response.data;
};

/**
 * Actualiza una licencia de empresa existente.
 * @param {UpdateCompanyLicenseDto} data - Datos para actualizar
 * @returns {Promise<ApiResponse<boolean>>}
 */
export const updateCompanyLicense = async (data) => {
  const response = await axiosInstance.put(BASE_URL, data);
  return response.data;
};

/**
 * Elimina (soft delete) una licencia de empresa por su ID.
 * @param {string} id - ID de la licencia
 * @returns {Promise<ApiResponse<boolean>>}
 */
export const deleteCompanyLicense = async (id) => {
  const response = await axiosInstance.delete(`${BASE_URL}/${id}`);
  return response.data;
};
